import { render, staticRenderFns } from "./PromotedListBuyBox.vue?vue&type=template&id=69e7422a&scoped=true"
import script from "./PromotedListBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedListBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedListBuyBox.vue?vue&type=style&index=0&id=69e7422a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e7422a",
  null
  
)

export default component.exports